<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="តំបន់ដឹកជញ្ជូនទាំងអស់" name="first"></el-tab-pane>
			<el-tab-pane label="បង្កើតតំបន់ថ្មី" name="second"></el-tab-pane>
			<el-tab-pane label="ចាត់តាំងអ្នកដឹកជញ្ជូនទៅតាមតំបន់" name="third"></el-tab-pane>
		</el-tabs>

		<div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<!-- <md-table-head>n.o</md-table-head> -->
					<md-table-head>តំបន់</md-table-head>
					<md-table-head>ទីតាំងដឹកជញ្ជូនទាំងអស់</md-table-head>
					<md-table-head>អ្នកដឹកតាមតំបន់ទាំងអស់</md-table-head>
				</md-table-row>
				<md-table-row v-for="(zone, index) in zoneList">
					<!-- <md-table-cell>{{index + 1}}</md-table-cell> -->
					<md-table-cell>
						<b>{{zone.name}}</b>
						<router-link :to="'zones/edit/' + zone.id">
							<md-button class="md-just-icon md-simple md-info">
								<md-icon>edit</md-icon>
								<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
							</md-button>
						</router-link>
					</md-table-cell>
					<md-table-cell>

						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<p><span v-for="location in zone.location">【{{location.name}}】</span></p>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-70">
								<md-field>
									<label>ឈ្មោះទីតាំងថ្មី</label>
									<md-input type="text" v-model="newLocationList[index].new_location">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-size-30">
								<md-button class="md-raised md-primary" style="width: 100%"
									@click="newLocation(zone.id, index)">បង្កើត</md-button>
							</div>
						</div>
					</md-table-cell>
					<md-table-cell>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-100 md-size-100">
								<ul v-if="zone.driver.length > 0">
									<li v-for="delivery in zone.driver"
										style="display: flex; justify-content: left; align-items: center;">
										<span>{{delivery.name}}</span>
										<md-button class="md-just-icon md-simple md-danger"
											@click="removeDriverZone(delivery.id, zone.id)">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">លុបចេញពីតំបន់នេះ</md-tooltip>
										</md-button>
									</li>
								</ul>
								<span v-else><b>មិនមានអ្នកដឹកជញ្ជូន</b></span>
							</div>
						</div>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<div v-if="tabName == 'second'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីតំបន់</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>ឈ្មោះតំបន់ដឹកជញ្ជូន *</label>
								<md-input type="text" v-model="zone.name"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-50 md-size-70">
							<md-field>
								<label>បញ្ចូលទីតាំងក្នុងតំបន់ *</label>
								<md-input type="text" v-model="zone.location" @keyup.enter="addLocation()"></md-input>
							</md-field>
						</div>
						<div class="md-layout-item md-small-size-50 md-size-30">
							<md-button class="md-raised md-primary" @click="addLocation()" style="width: 100%">ដាក់បញ្ចូល
							</md-button>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះតំបន់</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(zone.name).length > 0">{{zone.name}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>ទីតាំងក្នុងតំបន់នេះ</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<div v-if="zone.locationList.length > 0">
										<span v-for="(location, index) in zone.locationList"
											style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
											<span>{{location}}</span>
											<md-button class="md-just-icon md-simple md-danger" @click="removeLocation(index)">
												<md-icon>remove</md-icon>
												<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
											</md-button>
										</span>
									</div>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createZone()">បង្កើតតំបន់ថ្មី</md-button>
				</div>
			</div>
		</div>
		<div v-if="tabName == 'third'">
			<div class="md-layout">
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានអំពីតំបន់របស់អ្នកដឹកជញ្ជូន</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100 text-right">
						<span class="late">* តម្រូវឱ្យបំពេញ</span>
					</div>
					<div class="md-layout">
						<div class="md-layout-item md-small-size-100 md-size-100">
							<md-field>
								<label>តំបន់ដឹកជញ្ជូន *</label>
								<md-select placeholder="តំបន់ដឹកជញ្ជូន *" v-model="delivery.zone_id">
									<md-option :value="zone.id" v-for="zone in zoneList">{{zone.name}}</md-option>
								</md-select>
							</md-field>
						</div>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>អ្នកដឹកជញ្ជូន *</h3>
						<div class="md-layout">
							<div class="md-layout-item md-small-size-70 md-size-70">
								<md-field>
									<label>ស្វែងរកតាមរយៈ ឈ្មោះ លេខទូរស័ព្ទ ឬ ID</label>
									<md-input type="text" v-model="delivery.text" @keyup.enter="searchDriver()">
									</md-input>
								</md-field>
							</div>
							<div class="md-layout-item md-small-size-30 md-size-30">
								<md-button class="md-raised md-primary" @click="searchDriver()" style="width: 100%">ស្វែងរក
								</md-button>
							</div>
							<div class="md-layout-item md-small-size-100 md-size-100">
								<md-table>
									<md-table-row v-for="(driver, index) in delivery.driverList">
										<md-table-cell>
											<img src="@/assets/img/default-member.png" style="width: 34px; margin-right:5px">
											<b>ID: {{driver.hash_id}}</b> ({{driver.name}}, {{driver.phone}})
										</md-table-cell>
										<md-table-cell class="text-right">
											<md-button class="md-just-icon md-simple md-success" @click="addDriver(driver)">
												<md-icon>add</md-icon>
												<md-tooltip md-direction="top">ដាក់អ្នកដឹកជញ្ជូន</md-tooltip>
											</md-button>
										</md-table-cell>
									</md-table-row>
								</md-table>
							</div>
						</div>
					</div>
				</div>
				<div class="md-layout-item md-small-size-100 md-size-50">
					<div class="md-layout-item md-small-size-100 md-size-100">
						<h3>ព័ត៌មានសង្ខេប</h3>
					</div>
					<div class="md-layout-item md-small-size-100 md-size-100">
						<md-table>
							<md-table-row>
								<md-table-cell style="width: 50%;">ឈ្មោះតំបន់</md-table-cell>
								<md-table-cell style="width: 5px">:</md-table-cell>
								<md-table-cell>
									<span v-if="String(delivery.zone_id).length > 0">{{getZoneName}}</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
							<md-table-row>
								<md-table-cell>អ្នកដឹកជញ្ជូន</md-table-cell>
								<md-table-cell>:</md-table-cell>
								<md-table-cell>
									<span v-if="String(delivery.driver_id).length > 0"
										style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
										<span><b>ID: {{delivery.driver_hash_id}} ({{delivery.driver_name}})</b></span>
										<md-button class="md-just-icon md-simple md-danger" @click="removeDriver()">
											<md-icon>remove</md-icon>
											<md-tooltip md-direction="top">ដកចេញ</md-tooltip>
										</md-button>
									</span>
									<span v-else>មិនទាន់មាន</span>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</div>
				<div class="md-layout-item md-size-100 text-right">
					<md-button class="md-raised md-primary" @click="createDriverZone()">បញ្ចូល</md-button>
				</div>
			</div>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getZone();
		},
		data() {
			return {
				tabName: 'first',
				tagList: [],
				zone: {
					name: "",
					location: "",
					locationList: []
				},
				delivery: {
					text: "",
					driverList: [],
					driver_id: "",
					driver_name: "",
					driver_hash_id: "",
					zone_id: ""
				},
				zoneList: [],
				newLocationList: []
			}
		},
		computed: {
			getZoneName() {
				if (String(this.delivery.zone_id).length > 0) {
					for (let i = 0; i < this.zoneList.length; i++) {
						if (this.delivery.zone_id == this.zoneList[i].id) {
							return this.zoneList[i].name;
						}
					}
				} else {
					return "មានបញ្ហា"
				}
			}
		},
		methods: {
			getZone() {
				this.$http.get(this.config.api + "/admin/zone/get/list").then(data => {
					this.zoneList = data.body.data
					for (let i = 0; i < this.zoneList.length; i++) {
						this.newLocationList.push({ new_location: "" });
					}
				})
			},
			searchDriver() {
				this.$http.post(this.config.api + "/admin/driver/search", {
					text: this.delivery.text,
					status: "",
					offset: 0
				}).then(data => {
					this.delivery.text = "";
					this.delivery.driverList = data.body.data;
					this.$forceUpdate();
				})
			},
			createZone() {
				if (this.checkValidationZone()) {
					this.$http.post(this.config.api + "/admin/zone/post", {
						zone: this.zone
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "តំបន់ត្រូវបានបង្កើតឡើងដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.getZone();
							this.zone = { name: "", locationList: [] }
							this.tabName = 'first';

							// this.getSettings();

						}
					})
				}
			},
			checkValidationZone() {
				if (String(this.zone.name).length > 3 && this.zone.locationList.length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់គ្រាន់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			createDriverZone() {
				if (this.checkValidationDriverZone()) {
					this.$http.post(this.config.api + "/admin/zone/post_driver", {
						zone_id: this.delivery.zone_id,
						driver_id: this.delivery.driver_id
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "អ្នកដឹកជញ្ជូនត្រូវបានដាក់ចូលតំបន់ដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.tabName = 'first';
							this.delivery = { zone_id: "", driver_id: "" }
							// this.getSettings();
							this.getZone();
						}
					})
				}
			},
			checkValidationDriverZone() {
				if (String(this.delivery.zone_id).length > 0 && String(this.delivery.driver_id).length > 0) {
					return true;
				} else {
					this.$notification.notify({
						message: "ព័ត៌មានមិនគ្រប់គ្រាន់ សូមពិនិត្យមើលម្តងទៀត។",
						icon: 'error',
						type: 'danger'
					})
					return false;
				}
			},
			removeDriverZone(driver_id, zone_id) {
				// console.log(driver_id + zone_id)
				// console.log(driver_id);
				// console.log(zone_id);
				this.$http.post(this.config.api + "/admin/zone/delete_driver", {
					zone_id: zone_id,
					driver_id: driver_id
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "អ្នកដឹកជញ្ជូនត្រូវបានដកចេញពីតំបន់ដោយជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.tabName = 'first';
						// this.delivery = { zone_id: "", driver_id: "" }
						// this.getSettings();
						this.getZone();
					}
				})
			},
			newLocation(zone_id, index) {
				let name = this.newLocationList[index].new_location;
				if (String(name).length > 1) {
					this.$http.post(this.config.api + "/admin/zone/new_location", {
						zone_id: zone_id,
						name: name
					}).then(res => {
						if (res.body.status == 'success') {
							this.$notification.notify({
								message: "ទីតាំងត្រូវបានបង្កើតដោយជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
							this.newLocationList[index].new_location = "";
							this.tabName = 'first';
							this.getZone();
						}
					})
				}

			},
			addLocation() {
				if (String(this.zone.location).length > 0) {
					this.zone.locationList.push(this.zone.location);
					this.zone.location = "";
				}
			},
			addDriver(driver) {
				this.delivery.driver_id = driver.id;
				this.delivery.driver_name = driver.name;
				this.delivery.driver_hash_id = driver.hash_id;
				this.delivery.driverList = [];
			},
			removeDriver() {
				this.delivery.driver_id = "";
				this.delivery.driver_name = "";
				this.delivery.driver_hash_id = "";
			},
			removeLocation(index) {
				this.zone.locationList.splice(index, 1);
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Zones/View.vue